import { useContext } from 'react';
import { createContext } from 'react';
import { useCssHandles } from '../../../../utils/functions';
import { useProductSummary } from '../../../product-summary/ProductSummary/hooks/useProductSummary';

import { SkuSelectorProps } from '../@types/SkuSelectorProps';

export const SkuSelectorContext = createContext<any>({} as SkuSelectorProps);

SkuSelectorContext.displayName = 'SkuSelector';
const CSS_HANDLES = [
	'skuSelectorItem',
	'skuSelectorContainer',
	'frameAround',
	'skuSelectorInternalBox',
	'skuSelectorItemImageValue',
	'valueWrapper',
];

const SkuSelectorProvider = (props: SkuSelectorProps) => {
	const prodSum = useProductSummary();
	const { handles, withModifiers } = useCssHandles('vtex-product-summary-2-x', CSS_HANDLES, props?.blockClass);
	return (
		<SkuSelectorContext.Provider value={{ ...props, prodSum, handles, withModifiers }}>
			{props.children}
		</SkuSelectorContext.Provider>
	);
};

export const useSkuSelector = () => {
	const context = useContext(SkuSelectorContext);

	return context;
};

export default SkuSelectorProvider;
